/* import __COLOCATED_TEMPLATE__ from './plaid-linking-account-owner-role-step.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();